import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { CorrectAnswersRateListService } from '../services/LearningListService';
import LearningCorrectAnswersRateGauge from './LearningCorrectAnswersRateGauge';

class LearningCorrectAnswersRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    CorrectAnswersRateListService.load();
  }

  render() {
    return (
      <LearningCorrectAnswersRateGauge
        loading={CorrectAnswersRateListService.fetch.fetching}
        value={toJS(CorrectAnswersRateListService.global)}
        formatter={CorrectAnswersRateListService.getFormattedValue}
      />
    );
  }
}

export default observer(LearningCorrectAnswersRateGaugeContainer);
